module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "/user/userTrackList"
    }
  }, [_vm._v("学员跟踪记录")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("添加跟踪记录-教材配送记录")])], 1)], 1), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "寄送教材",
      "prop": "bookMaterialLevel"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.formValidate.bookMaterialLevel),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "bookMaterialLevel", $$v)
      },
      expression: "formValidate.bookMaterialLevel"
    }
  }, [_c('OptionGroup', {
    attrs: {
      "label": "Pre"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Pre 1"
    }
  }, [_vm._v("Pre 1")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Pre 2"
    }
  }, [_vm._v("Pre 2")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Pre 3"
    }
  }, [_vm._v("Pre 3")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Pre 4"
    }
  }, [_vm._v("Pre 4")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Pre 5"
    }
  }, [_vm._v("Pre 5")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Pre 6"
    }
  }, [_vm._v("Pre 6")])], 1), _vm._v(" "), _c('OptionGroup', {
    attrs: {
      "label": "Phonics"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Phonics 1"
    }
  }, [_vm._v("Phonics 1")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Phonics 2"
    }
  }, [_vm._v("Phonics 2")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Phonics 3"
    }
  }, [_vm._v("Phonics 3")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Phonics 4"
    }
  }, [_vm._v("Phonics 4")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Phonics 5"
    }
  }, [_vm._v("Phonics 5")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Phonics 6"
    }
  }, [_vm._v("Phonics 6")])], 1), _vm._v(" "), _c('OptionGroup', {
    attrs: {
      "label": "G"
    }
  }, [_c('Option', {
    attrs: {
      "value": "G-1A"
    }
  }, [_vm._v("G-1A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-1B"
    }
  }, [_vm._v("G-1B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-2A"
    }
  }, [_vm._v("G-2A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-2B"
    }
  }, [_vm._v("G-2B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-3A"
    }
  }, [_vm._v("G-3A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-3B"
    }
  }, [_vm._v("G-3B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-4A"
    }
  }, [_vm._v("G-4A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-4B"
    }
  }, [_vm._v("G-4B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-5A"
    }
  }, [_vm._v("G-5A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-5B"
    }
  }, [_vm._v("G-5B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-6A"
    }
  }, [_vm._v("G-6A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "G-6B"
    }
  }, [_vm._v("G-6B")])], 1), _vm._v(" "), _c('OptionGroup', {
    attrs: {
      "label": "JS"
    }
  }, [_c('Option', {
    attrs: {
      "value": "JS1A"
    }
  }, [_vm._v("JS1A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "JS1B"
    }
  }, [_vm._v("JS1B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "JS2A"
    }
  }, [_vm._v("JS2A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "JS2B"
    }
  }, [_vm._v("JS2B")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "JS3A"
    }
  }, [_vm._v("JS3A")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "JS3B"
    }
  }, [_vm._v("JS3B")])], 1), _vm._v(" "), _c('OptionGroup', {
    attrs: {
      "label": "Wonders"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Wonders 无教材"
    }
  }, [_vm._v("Wonders 无教材")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4,
      "offset": 1
    }
  }, [_c('Button', {
    attrs: {
      "icon": "trash-a"
    },
    on: {
      "click": _vm.allClear
    }
  }, [_vm._v("清空教材")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "邮寄地址",
      "prop": "address"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "必填"
    },
    model: {
      value: (_vm.formValidate.address),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "address", $$v)
      },
      expression: "formValidate.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 9
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期",
      "prop": "nextHandlerTime"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value": _vm.formValidate.nextHandlerTime
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 7
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人",
      "prop": "nextHandlerId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.formValidate.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextHandlerId", _vm._n($$v))
      },
      expression: "formValidate.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "operateStatus"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formValidate.operateStatus),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "operateStatus", $$v)
      },
      expression: "formValidate.operateStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未处理")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已处理")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1032993a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/AddSendMaterialRecords.vue
// module id = 1623
// module chunks = 8